<template>
  <DialogUserTemplate class="dialog" :scrollable="true" v-bind="props">
    <div class="image">
      <slot name="image" />
    </div>
    <div class="content">
      <h3 v-cleaned="titleHtml" />
      <slot />
    </div>
  </DialogUserTemplate>
</template>
<script lang="ts" setup>
interface Props {
  titleHtml: string;
  appEventShare: UseAppEventShare;
  forced: boolean;
}

const props = defineProps({
  titleHtml: null,
  appEventShare: null,
  forced: { type: Boolean }
});

onMounted(() => {
  if (props.forced) {
    props.appEventShare.forcedOpenSendParentInfo();
  } else {
    props.appEventShare.openSendParentInfo();
  }
});
</script>
<style lang="scss" scoped>
.dialog {
  max-width: 45rem;

  :deep(.content) {
    gap: var(--gap_l);
  }
}

h3 {
  @include font('m', 800, 'secondary');

  text-align: center;
}

p {
  @include font('n', 400, 'secondary');

  text-align: center;
}

// .image {
//   width: 100%;
//   height: 16.3rem;
//   margin-bottom: var(--gap_xl);
//   background-image: url('~/assets/images/exercise/exercise-mail.svg');
//   background-repeat: no-repeat;
//   background-position: center;
//   background-size: contain;
// }

.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
  align-items: center;
}

form {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  align-items: center;
  width: 100%;
}

input {
  width: 100%;
  padding: var(--gap_s) var(--gap_m);
  transition: border 200ms $ease-out-quad;
  border-radius: var(--border_radius);
  border-color: var(--color_secondary_lighter);
  background-color: var(--color_neutral_25);
  color: var(--color_neutral_900);
  font-size: var(--font_size_m);
  text-align: center;
  @include stroke('m', 'm');
  &:focus {
    border-color: var(--color_secondary);
  }
}

.button {
  width: 100%;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
